import React from 'react';
import { Outlet } from '@tanstack/react-router';

export interface PageLayoutProps {
  children: React.ReactNode;
}

export function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className="mx-auto w-full max-w-[1440px] px-0 md:px-8 lg:px-12 xl:px-16">
      {children}
    </div>
  );
} 